import { render } from "./Hermes.vue?vue&type=template&id=6a10d03e"
import script from "./Hermes.vue?vue&type=script&lang=ts"
export * from "./Hermes.vue?vue&type=script&lang=ts"
script.render = render

export default script